import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useProfile } from '../hooks/UserHooks';
import { Loader2 } from 'lucide-react';

const AuthProtected = (props: any) => {
    const { userProfile, loading } = useProfile();
    const location = useLocation();

    if (loading) {
        return (
            <div className="flex h-screen items-center justify-center">
                <Loader2 className="size-8 animate-spin text-muted-foreground" />
            </div>
        );
    }

    if (!userProfile) {
        const redirectParam = location.pathname !== '/'
            ? `?redirect=${encodeURIComponent(location.pathname + location.search)}`
            : '';
        return (
            <Navigate to={`/login${redirectParam}`} />
        );
    }

    return <>{props.children}</>;
};

export default AuthProtected;
